import BoardCreate from './BoardCreate';

export default BoardCreate;
